module.exports = __webpack_public_path__ + "img/spins_1.5.81b275ac.png";